import { graphql } from '../../gql';

export const API_AKTIVIEREN = graphql(`
  mutation E2nApiAktiviereApi {
    aktiviereApi {
      __typename
    }
  }
`);

export const API_DEAKTIVIEREN = graphql(`
  mutation E2nApiDeaktiviereApi {
    deaktiviereApi {
      __typename
    }
  }
`);

export const ZUGANG_AKTIVIEREN = graphql(`
  mutation E2nApiAktiviereZugang($uidZugang: String!) {
    aktiviereZugang(uidZugang: $uidZugang) {
      __typename
    }
  }
`);

export const ZUGANG_DEAKTIVIEREN = graphql(`
  mutation E2nApiDeaktiviereZugang($uidZugang: String!) {
    deaktiviereZugang(uidZugang: $uidZugang) {
      __typename
    }
  }
`);

export const ZUGANG_LOESCHEN = graphql(`
  mutation E2nApiLoescheZugang($uidZugang: String!) {
    loescheZugang(uidZugang: $uidZugang) {
      __typename
    }
  }
`);

export const ZUGANG_ERSTELLEN = graphql(`
  mutation E2nApiErstelleZugang($input: ZugangErstellenInput) {
    erstelleZugang(zugangErstellenInput: $input) {
      __typename
      ... on ZugangErstellenSuccess {
        zugang {
          uid
          aktiv
          apiKey
          beschreibung
          endpunktDefinitionen {
            endpunktName
            httpMethode
            attribute
          }
        }
      }
      ... on ZugangErstellenLimitReached {
        zugangLimit
      }
      ... on ZugangErstellenBeschreibungTooLong {
        maxAllowedLength
      }
    }
  }
`);

export const ZUGANG_BEARBEITEN = graphql(`
  mutation E2nApiBearbeiteZugang($input: ZugangBearbeitenInput!) {
    bearbeiteZugang(zugangBearbeitenInput: $input) {
      __typename
      ... on ZugangBearbeitenSuccess {
        zugang {
          uid
          aktiv
          apiKey
          beschreibung
          endpunktDefinitionen {
            endpunktName
            httpMethode
            attribute
          }
        }
      }
      ... on ZugangBearbeitenBeschreibungTooLong {
        maxAllowedLength
      }
    }
  }
`);

export const ENDPUNKTE_SPEICHERN = graphql(`
  mutation E2nApiSaveEndpunktDefinitionen(
    $zugangUid: String!
    $endpunktDefinitionen: [EndpunktDefinitionInput!]!
  ) {
    saveEndpunktDefinitionen(
      zugangUid: $zugangUid
      endpunktDefinitionen: $endpunktDefinitionen
    ) {
      __typename
    }
  }
`);
